<div class="wave {{ color }}">
  <div class="spinner-rect rect1"></div>
  <div class="spinner-rect rect2"></div>
  <div class="spinner-rect rect3"></div>
  <div class="spinner-rect rect4"></div>
  <div class="spinner-rect rect5"></div>
</div>
